import {
  GET_ATTENDANCE_LIST,
  SHOW_ATTENDANCE_USER_DETAIL,
  SHOW_ATTENDANCE_DETAIL,
  GET_ATTENDANCE_DATE_DETAIL,
  PDF_DAILY_REPORT,
  ADMIN_ATTENDANCE_UPDATE,
  APPROVAL_ATTENDANCE_UPDATE,
  FORCE_APPROVAL_REJECTION,
  SET_APPROVAL_ATTENDANCE,
  SET_APPROVAL_ATTENDANCE_ALL,
  SET_APPROVAL_LEAVE,
  SET_APPROVAL_OVERTIME,
  UPDATE_ALL_APPROVALED,
  CHECK_LEAVE_REASON,
  IMPORT_CSV_PAID_LEAVE
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_ATTENDANCE_LIST]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_ATTENDANCE_USER_DETAIL]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances/show_attendance_user_detail",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_ATTENDANCE_DETAIL]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances/show_attendance_detail",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_ATTENDANCE_DATE_DETAIL]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances/get_attendance_date_detail",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [PDF_DAILY_REPORT]({ dispatch }, params) {
      const res = await dispatch("apiBlobDownload", {
        url: "/kanri/attendances/daily_reports_pdf",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [ADMIN_ATTENDANCE_UPDATE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/admin_attendance_update",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [APPROVAL_ATTENDANCE_UPDATE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/approval_attendance_update",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [FORCE_APPROVAL_REJECTION]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/force_approval_rejection",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SET_APPROVAL_ATTENDANCE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/set_approval_attendance",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SET_APPROVAL_ATTENDANCE_ALL]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/set_approval_attendance_all",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SET_APPROVAL_LEAVE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/set_approval_leave",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SET_APPROVAL_OVERTIME]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/set_approval_overtime",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [UPDATE_ALL_APPROVALED]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/update_all_approvaled",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CHECK_LEAVE_REASON]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances/check_leave_reason",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [IMPORT_CSV_PAID_LEAVE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/attendances/import_csv_paid_leave",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
